import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";

import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Master from "./Master";

import { LoadingDiv, SweetAlertShow, closeModal } from "../master/Master";

import {
  collectionDistributionItemFieldsList,
  collectionDistributionItemFieldAdd,
  collectionDistributionItemFieldUpdate,
  collectionDistributionItemFieldDelete,
} from "../../api/CollectionDistribution";

export default function ItemFields() {
  const [searchParams] = useSearchParams();

  const item_id = searchParams.get("item_id");

  const [loading, setLoading] = useState(false);

  const [fields, setFields] = useState([]);

  const [modelData, setModelData] = useState({});

  const getFields = async () => {
    setLoading(true);

    try {
      const response = await collectionDistributionItemFieldsList(
        item_id
      );

      if (response?.data?.status) {
        setFields(response?.data?.data || []);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message || error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const formData = new FormData(e.target);

      formData.append("item_id", item_id);

      const response = await collectionDistributionItemFieldAdd(formData);

      if (response?.data?.status) {
        SweetAlertShow("success", "Success", response?.data?.message);

        e.target.reset();

        closeModal("addField");

        getFields();
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message || error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const formData = new FormData(e.target);

      const response = await collectionDistributionItemFieldUpdate(formData);

      if (response?.data?.status) {
        SweetAlertShow("success", "Success", response?.data?.message);

        closeModal("updateField");

        getFields();
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message || error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    setLoading(true);

    try {
      const response = await collectionDistributionItemFieldDelete(id);

      if (response?.data?.status) {
        SweetAlertShow("success", "Success", response?.data?.message);

        getFields();
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message || error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFields();
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid mt-3">
                <div className="row">
                  <Master />

                  <div className="col-md-10">
                    <div className="card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h4 className="text-primary m-0">Item Fields</h4>

                          <button
                            className="btn btn-primary btn-sm"
                            data-bs-toggle="modal"
                            data-bs-target="#addField"
                          >
                            <i className="bi bi-plus-circle me-2"></i>
                            Add Field
                          </button>
                        </div>

                        <div className="table-responsive">
                          <table className="table table-bordered table-hover text-center align-middle">
                            <thead className="table-primary">
                              <tr>
                                <th>#</th>
                                <th>Field Label</th>
                                <th>Field Name</th>
                                <th>Field Type</th>
                                <th>Required</th>
                                <th>Options</th>
                                <th>Order</th>
                                <th>Action</th>
                              </tr>
                            </thead>

                            <tbody>
                              {fields?.length > 0 ? (
                                fields?.map((item, i) => (
                                  <tr key={item?.id}>
                                    <td>{i + 1}</td>

                                    <td>{item?.field_label}</td>

                                    <td>
                                      <code>{item?.field_name}</code>
                                    </td>

                                    <td>
                                      <span className="badge bg-label-primary">
                                        {item?.field_type}
                                      </span>
                                    </td>

                                    <td>
                                      <span
                                        className={`badge ${
                                          item?.is_required === "Yes"
                                            ? "bg-success"
                                            : "bg-secondary"
                                        }`}
                                      >
                                        {item?.is_required}
                                      </span>
                                    </td>

                                    <td>{item?.field_options}</td>

                                    <td>{item?.field_order}</td>

                                    <td>
                                      <div className="d-flex justify-content-center gap-2">
                                        <button
                                          className="btn btn-sm btn-outline-info"
                                          data-bs-toggle="modal"
                                          data-bs-target="#updateField"
                                          onClick={() => setModelData(item)}
                                        >
                                          <i className="ri-edit-line"></i>
                                        </button>

                                        <button
                                          className="btn btn-sm btn-outline-danger"
                                          onClick={() => {
                                            Swal.fire({
                                              title: "Are you sure?",
                                              text: "This field will be deleted.",
                                              icon: "warning",
                                              showCancelButton: true,
                                              confirmButtonText: "Yes Delete",
                                            }).then((result) => {
                                              if (result.isConfirmed) {
                                                handleDelete(item?.id);
                                              }
                                            });
                                          }}
                                        >
                                          <i className="ri-delete-bin-line"></i>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="8">No Fields Found</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ADD FIELD */}

      <div
        className="modal fade"
        id="addField"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleAdd}>
              <div className="modal-header bg-label-primary">
                <h5 className="modal-title">Add Field</h5>

                <button className="btn-close" data-bs-dismiss="modal"></button>
              </div>

              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Field Label</label>

                  <input
                    type="text"
                    className="form-control input-capitalize"
                    name="field_label"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Field Name</label>

                  <input
                    type="text"
                    className="form-control input-uppercase"
                    name="field_name"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Field Type</label>

                  <select className="form-select" name="field_type" required>
                    <option value="text">Text</option>

                    <option value="number">Number</option>

                    <option value="date">Date</option>

                    <option value="textarea">Textarea</option>

                    <option value="select">Select</option>

                    <option value="checkbox">Checkbox</option>

                    <option value="radio">Radio</option>

                    <option value="file">File</option>
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Required</label>

                  <select className="form-select" name="is_required">
                    <option value="No">No</option>

                    <option value="Yes">Yes</option>
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Field Options</label>

                  <textarea
                    className="form-control"
                    rows={3}
                    name="field_options"
                    placeholder="Red,Blue,Green"
                  ></textarea>

                  <small className="text-muted">
                    Only for select, checkbox, radio
                  </small>
                </div>

                <div className="mb-3">
                  <label className="form-label">Field Order</label>

                  <input
                    type="number"
                    className="form-control"
                    name="field_order"
                    defaultValue={0}
                  />
                </div>
              </div>

              <div className="modal-footer bg-label-primary">
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* UPDATE FIELD */}

      <div
        className="modal fade"
        id="updateField"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleUpdate}>
              <div className="modal-header bg-label-primary">
                <h5 className="modal-title">Update Field</h5>

                <button className="btn-close" data-bs-dismiss="modal"></button>
              </div>

              <div className="modal-body">
                <input type="hidden" name="id" value={modelData?.id || ""} />

                <div className="mb-3">
                  <label className="form-label">Field Label</label>

                  <input
                    type="text"
                    className="form-control input-capitalize"
                    name="field_label"
                    defaultValue={modelData?.field_label}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Field Name</label>

                  <input
                    type="text"
                    className="form-control input-uppercase"
                    name="field_name"
                    defaultValue={modelData?.field_name}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Field Type</label>

                  <select
                    className="form-select"
                    name="field_type"
                    defaultValue={modelData?.field_type}
                  >
                    <option value="text">Text</option>

                    <option value="number">Number</option>

                    <option value="date">Date</option>

                    <option value="textarea">Textarea</option>

                    <option value="select">Select</option>

                    <option value="checkbox">Checkbox</option>

                    <option value="radio">Radio</option>

                    <option value="file">File</option>
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Required</label>

                  <select
                    className="form-select"
                    name="is_required"
                    defaultValue={modelData?.is_required}
                  >
                    <option value="No">No</option>

                    <option value="Yes">Yes</option>
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Field Options</label>

                  <textarea
                    className="form-control"
                    rows={3}
                    name="field_options"
                    defaultValue={modelData?.field_options}
                  ></textarea>
                </div>

                <div className="mb-3">
                  <label className="form-label">Field Order</label>

                  <input
                    type="number"
                    className="form-control"
                    name="field_order"
                    defaultValue={modelData?.field_order}
                  />
                </div>
              </div>

              <div className="modal-footer bg-label-primary">
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button type="submit" className="btn btn-primary">
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
